import * as React from 'react';

import { IMessagePage, IParsedMessage } from '../../../utils/messageUtils';

function createMessagePage([year, month, day]: [number, number, number], timeCode: string): IMessagePage {
  return {
    date: new Date(year, month, day).getTime(),
    messages: [],
    timeCode,
  };
}

export const useMessagesPages = (chatMessages: IParsedMessage[]): IMessagePage[] => {
  const pages = React.useMemo(() => {
    const pages: IMessagePage[] = [];

    chatMessages.forEach(message => {
      // timePageKey - идентификатор в виде Год/Месяц/Число
      const pageIndex = pages.findIndex(({ timeCode }) => timeCode === message.timePageKey);

      // если есть страница, обновляем ее
      if (pageIndex >= 0) {
        pages[pageIndex] = {
          ...pages[pageIndex],
          messages: pages[pageIndex].messages.concat(message),
        };

        return;
      }

      // создаем новую страницу и добавляем в нее сообщение
      // timePage - массив даты [Год, Месяц, Число]
      const page = createMessagePage(message.timePage, message.timePageKey);

      page.messages.push(message);

      pages.push(page);

      return;
    });

    return pages;
  }, [chatMessages]);

  return pages || [];
};
